(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-pro"] && !Shopify.designMode) return;
  try {
    
  class LuniaHeader extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section') || this.parentElement;
      this.stickyType = this.dataset.sticky || 'none';
      this.openMode = this.dataset.openMode || 'hover';
      this.openDelay = parseInt(this.dataset.openDelay || '0', 10);
      this.closeDelay = parseInt(this.dataset.closeDelay || '150', 10);
      this.breakpoint = parseInt(this.dataset.breakpoint || '990', 10);
      this.accordionSingle = this.dataset.accordionSingle === 'true';

      this.items = Array.from(this.querySelectorAll('[data-lh-item]'));
      this.backdrop = this.querySelector('[data-lh-backdrop]');
      this.nav = this.querySelector('[data-lh-nav]');
      this.scrim = this.querySelector('[data-lh-scrim]');

      this.openTimer = null;
      this.closeTimer = null;
      this.placeholder = null;

      this.setHeights();
      this.bindMenu();
      this.bindDrawer();
      this.bindSticky();

      this.onResize = this.debounce(() => {
        this.setHeights();
        if (!this.isMobile()) this.closeDrawer();
        else this.closeAll();
      }, 150);
      window.addEventListener('resize', this.onResize);

      document.addEventListener('keydown', this.onKeydown = (e) => {
        if (e.key !== 'Escape') return;
        this.closeAll();
        this.closeDrawer();
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('keydown', this.onKeydown);
    }

    debounce(fn, wait) {
      let t;
      return (...args) => { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait); };
    }

    setHeights() {
      const h = this.querySelector('.lh__wrapper');
      if (!h) return;
      const height = h.offsetHeight;
      document.documentElement.style.setProperty('--lunia-header-height', height + 'px');
      document.documentElement.style.setProperty('--header-height', height + 'px');
      this.headerHeight = height;
    }

    /* ---------------- menu ---------------- */
    bindMenu() {
      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-lh-trigger]');
        if (!trigger) return;

        if (this.openMode === 'hover') {
          item.addEventListener('mouseenter', () => {
            if (this.isMobile()) return;
            clearTimeout(this.closeTimer);
            this.openTimer = setTimeout(() => this.open(item), this.openDelay);
          });
          item.addEventListener('mouseleave', () => {
            if (this.isMobile()) return;
            clearTimeout(this.openTimer);
            this.closeTimer = setTimeout(() => this.close(item), this.closeDelay);
          });
        }

        trigger.addEventListener('click', (e) => {
          if (this.isMobile()) return;
          const isOpen = item.classList.contains('is-open');
          if (this.openMode === 'click') {
            e.preventDefault();
            isOpen ? this.close(item) : this.open(item);
          } else if (!isOpen) {
            // hover mode on touch devices: first tap opens instead of navigating
            if (window.matchMedia('(hover: none)').matches) {
              e.preventDefault();
              this.open(item);
            }
          }
        });

        trigger.addEventListener('keydown', (e) => {
          if (this.isMobile()) return;
          if (e.key === 'Enter' || e.key === ' ') {
            if (this.openMode === 'click' || !item.classList.contains('is-open')) {
              e.preventDefault();
              this.open(item);
              const first = item.querySelector('[data-lh-panel] a');
              if (first) first.focus();
            }
          }
        });

        item.addEventListener('focusout', (e) => {
          if (this.isMobile()) return;
          if (!item.contains(e.relatedTarget)) this.close(item);
        });
      });

      if (this.backdrop) {
        this.backdrop.addEventListener('click', () => this.closeAll());
      }
    }

    open(item) {
      this.items.forEach((i) => { if (i !== item) this.close(i); });
      item.classList.add('is-open');
      const t = item.querySelector('[data-lh-trigger]');
      if (t) t.setAttribute('aria-expanded', 'true');
      if (this.section) this.section.classList.add('lh-panel-open');
    }

    close(item) {
      item.classList.remove('is-open');
      const t = item.querySelector('[data-lh-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (this.section && !this.querySelector('.lh__item.is-open')) {
        this.section.classList.remove('lh-panel-open');
      }
    }

    closeAll() {
      this.items.forEach((i) => this.close(i));
      if (this.section) this.section.classList.remove('lh-panel-open');
    }

    /* ---------------- drawer (same nav, mobile) ---------------- */
    isMobile() {
      return window.innerWidth < this.breakpoint;
    }

    bindDrawer() {
      const openBtn = this.querySelector('[data-lh-drawer-open]');
      const closeBtn = this.querySelector('[data-lh-drawer-close]');
      if (openBtn) openBtn.addEventListener('click', () => this.openDrawer());
      if (closeBtn) closeBtn.addEventListener('click', () => this.closeDrawer());
      if (this.scrim) this.scrim.addEventListener('click', () => this.closeDrawer());

      // On mobile the same triggers act as accordion toggles.
      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-lh-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', (e) => {
          if (!this.isMobile()) return;
          e.preventDefault();
          const isOpen = item.classList.contains('is-open');
          if (this.accordionSingle) {
            this.items.forEach((other) => { if (other !== item) this.close(other); });
          }
          isOpen ? this.close(item) : this.openAccordion(item);
        });
      });

      // Closing the drawer after tapping a link feels better than leaving it open.
      this.querySelectorAll('.lh__sublink, .lh__panel-footer a, .lh__promo').forEach((link) => {
        link.addEventListener('click', () => { if (this.isMobile()) this.closeDrawer(); });
      });
    }

    openAccordion(item) {
      item.classList.add('is-open');
      const t = item.querySelector('[data-lh-trigger]');
      if (t) t.setAttribute('aria-expanded', 'true');
    }

    openDrawer() {
      if (!this.nav) return;
      this.nav.classList.add('is-open');
      if (this.scrim) this.scrim.classList.add('is-open');
      if (this.section) this.section.classList.remove('lh-hidden');
      document.body.classList.add('overflow-hidden');
      document.body.style.overflow = 'hidden';
      const btn = this.querySelector('[data-lh-drawer-open]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      const first = this.nav.querySelector('a, button');
      if (first) first.focus();
    }

    closeDrawer() {
      if (!this.nav) return;
      this.nav.classList.remove('is-open');
      if (this.scrim) this.scrim.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
      document.body.style.overflow = '';
      const btn = this.querySelector('[data-lh-drawer-open]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }

    /* ---------------- sticky ---------------- */
    bindSticky() {
      if (this.stickyType === 'none' || !this.section) return;

      const alwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.lastScroll = window.pageYOffset;

      const stick = () => {
        if (this.section.classList.contains('lh-sticky')) return;
        if (!this.placeholder) {
          this.placeholder = document.createElement('div');
          this.placeholder.setAttribute('aria-hidden', 'true');
        }
        this.placeholder.style.height = this.section.offsetHeight + 'px';
        this.section.parentNode.insertBefore(this.placeholder, this.section);
        this.section.classList.add('lh-sticky');
        requestAnimationFrame(() => this.section.classList.add('lh-animate'));
      };

      const unstick = () => {
        this.section.classList.remove('lh-sticky', 'lh-hidden', 'lh-animate');
        if (this.placeholder && this.placeholder.parentNode) {
          this.placeholder.parentNode.removeChild(this.placeholder);
        }
      };

      this.onScroll = () => {
        const y = window.pageYOffset;
        const threshold = this.headerHeight || 80;

        this.section.classList.toggle('lh-scrolled', y > threshold);

        if (alwaysSticky) {
          if (y > threshold) stick(); else unstick();
        } else {
          if (y > threshold * 2) {
            stick();
            const goingDown = y > this.lastScroll;
            if (this.querySelector('.lh__item.is-open') || (this.nav && this.nav.classList.contains('is-open'))) {
              this.section.classList.remove('lh-hidden');
            } else {
              this.section.classList.toggle('lh-hidden', goingDown);
            }
          } else {
            unstick();
          }
        }
        this.lastScroll = y;
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
  }

  if (!customElements.get('lunia-header')) {
    customElements.define('lunia-header', LuniaHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ia-section-announcement-2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const marq = document.getElementById('ia-sections-marq');
    const orig = document.getElementById('ia-sections-orig');
    const clone = orig.cloneNode(true);
    clone.id = 'ia-sections-clone';
    marq.appendChild(clone);
  });

  } catch(e) { console.error(e); }
})();
})();
